import { Injectable } from '@angular/core';
import { AuthService } from '@features/auth/auth.service';
import { StorageService } from '@services/common/storage.service';
import { CrudService, GetEntityModel } from 'collection';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class TrialEndedService {
  subscriptionDetails: GetEntityModel;

  initSubscriptionDetails(): Observable<any> {
    return this.subscriptionDetails.get({ query: { expand: 'account' } }).pipe(
      map((response: any) => {
        if (response.success && response.data) {
          response.data.forEach((item) => {
            if (item.status === 'current') {
              this._localStorage.setItem('subscription', item);
              this._auth.setSubscription(item);

              return item;
            }
          });
        }
      })
    );
  }

  constructor(
    private _crud: CrudService,
    private _auth: AuthService,
    private _localStorage: StorageService
  ) {
    this.subscriptionDetails = this._crud.createGetEntity({ name: 'subscription' });
  }
}
